import PropTypes from "prop-types";
import { any } from "ramda";
import { useAuthContext } from "@authentication/context";
import { Link, Header3, Header2 } from "@base-ui";
import { StyledFooter, FooterSection, SectionsHolder } from "./footer.styles";
import skrLogo from "assets/ux/RGB_SKR_Logotype_neg.png";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Footer = function Footer(_ref) {
  var style = _ref.style,
    className = _ref.className;
  var _useAuthContext = useAuthContext(),
    getUserAccess = _useAuthContext.getUserAccess;
  var userAccess = getUserAccess();
  var authenticated = userAccess && any(function (key) {
    return userAccess[key];
  }, Object.keys(userAccess));
  return /*#__PURE__*/_jsxs(StyledFooter, {
    style: style,
    className: "".concat(className, " hide-while-printing"),
    children: [/*#__PURE__*/_jsx(Header2, {
      className: "hidden-styles",
      children: "V\xE5rden i siffror, sidfot"
    }), /*#__PURE__*/_jsxs(SectionsHolder, {
      children: [/*#__PURE__*/_jsxs(FooterSection, {
        children: [/*#__PURE__*/_jsx(Header3, {
          inverted: true,
          style: {
            paddingLeft: "18px"
          },
          id: "common-questions",
          children: "Vanliga fr\xE5gor"
        }), /*#__PURE__*/_jsxs("ul", {
          "aria-labelledby": "common-questions",
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/faq?activetab=instruktionsfilmer&open=hitta-en-indikator",
              children: "Hur anv\xE4nder jag V\xE5rden i siffor? \u2013 Instruktionsfilmer"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/faq?activetab=vanliga-fragor&open=vad-betyder-forkortningarna-msk-inv-unk-och-ni",
              children: "Vad betyder f\xF6rkortningarna MSK, INV, UNK och NI?"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/faq?activetab=vanliga-fragor&open=vilka-webblasare-stodjer-varden-i-siffror",
              children: "Vilka webbl\xE4sare st\xF6djer V\xE5rden i siffror?"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(FooterSection, {
        children: [/*#__PURE__*/_jsx(Header3, {
          inverted: true,
          style: {
            paddingLeft: "18px"
          },
          id: "about-vis",
          children: "Om V\xE5rden i siffror"
        }), /*#__PURE__*/_jsxs("ul", {
          "aria-labelledby": "about-vis",
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/om-varden-i-siffror?open=vad-finns-pa-varden-i-siffror",
              children: "Vad finns i V\xE5rden i siffror?"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/om-varden-i-siffror?open=vem-bestammer-vad-som-ska-visas-pa-varden-i-siffror",
              children: "Vem best\xE4mmer vad som ska finnas i verktyget V\xE5rden i siffror?"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/om-varden-i-siffror?open=vilka-krav-staller-varden-i-siffror-pa-en-indikator",
              children: "Vilka krav st\xE4ller V\xE5rden i siffror p\xE5 en indikator?"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/om-varden-i-siffror?open=vad-ar-en-vardenhet",
              children: "Vad \xE4r en v\xE5rdenhet?"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/utveckling",
              children: "Nya V\xE5rden i Siffror"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(FooterSection, {
        children: [/*#__PURE__*/_jsx(Header3, {
          inverted: true,
          style: {
            paddingLeft: "18px"
          },
          id: "skr-link",
          children: "SKR"
        }), /*#__PURE__*/_jsxs("ul", {
          "aria-labelledby": "skr-link",
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              inverted: "true",
              style: {
                width: "260px"
              },
              as: "a",
              to: "",
              href: "https://skr.se/halsaochsjukvard/patientinflytande/vardgarantiochtillganglighetivarden/kontaktavardenisiffror.9670.html",
              children: "Kontakta V\xE5rden i siffror"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/release-notes",
              children: "Release notes"
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "none",
              inverted: "true",
              to: "/tillganglighet-i-varden-i-siffror",
              children: "Tillg\xE4nglighet i V\xE5rden i siffror"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(FooterSection, {
        children: [/*#__PURE__*/_jsx(Header3, {
          inverted: true,
          style: {
            paddingLeft: "18px"
          },
          id: "admin-link",
          children: "Administration"
        }), /*#__PURE__*/_jsx("ul", {
          "aria-labelledby": "admin-link",
          children: /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Link, {
              icon: "logOut",
              inverted: "true",
              style: {
                width: "200px"
              },
              to: authenticated ? "/logout" : "/login?absPath=".concat(location.href),
              children: authenticated ? "Logga ut" : "Admin logga in"
            }, authenticated)
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("a", {
      href: "http://skr.se",
      "aria-label": "L\xE4nk till Sveriges Kommuner och Regioner",
      style: {
        display: "block",
        width: "3.5cm",
        height: "1.5cm",
        marginLeft: "15px",
        background: "url(".concat(skrLogo, ") no-repeat"),
        backgroundSize: "3.5cm"
      }
    })]
  });
};
Footer.propTypes = {
  authenticated: PropTypes.oneOf([true, false]),
  style: PropTypes.object,
  className: PropTypes.string
};
Footer.defaultProps = {
  authenticated: false
};
export default Footer;